import React, { useState, useEffect } from 'react';
import Sidebar from './Sidebar'; // MENÚ INTELIGENTE IMPORTADO
import { useNavigate } from 'react-router-dom';
import { BookOpen, Save, Plus, Calculator, Trash2 } from 'lucide-react';

const Calificaciones = () => {
  const navigate = useNavigate();
  
  // Catálogos del sistema
  const [periodos, setPeriodos] = useState([]);
  const [aulas, setAulas] = useState([]);
  const [cursos, setCursos] = useState([]);
  const [criterios, setCriterios] = useState([]);
  
  // Datos del salón seleccionado
  const [alumnos, setAlumnos] = useState([]);
  const [actividades, setActividades] = useState([]); 
  const [notas, setNotas] = useState({}); 
  
  // Filtros y Estados UI
  const [filtros, setFiltros] = useState({ periodoId: '', aulaId: '', cursoId: '', bimestre: 'Bimestre 1' });
  const [nuevaActividad, setNuevaActividad] = useState({ nombre: '', criterioId: '' });
  const [mostrandoFormulario, setMostrandoFormulario] = useState(false);
  const [guardando, setGuardando] = useState(false);

  // ESTADO DE SEGURIDAD (Para el botón borrar)
  const [rolUsuario, setRolUsuario] = useState('');

  useEffect(() => { 
    cargarDatosBase(); 
    extraerRolDeToken();
  }, []);

  useEffect(() => {
    if (filtros.periodoId) cargarAulas(filtros.periodoId);
  }, [filtros.periodoId]);

  const extraerRolDeToken = () => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        let rol = payload['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'] || payload.role || '';
        if (Array.isArray(rol)) rol = rol[0];
        setRolUsuario(String(rol).trim().toUpperCase());
      } catch (e) { console.error("Error leyendo rol", e); }
    }
  };

  const cargarDatosBase = async () => {
    const token = localStorage.getItem('token');
    if (!token) return navigate('/login');
    try {
      const [resPer, resCur, resCri] = await Promise.all([
        fetch(`${process.env.REACT_APP_API_URL}/Periodos`, { headers: { 'Authorization': `Bearer ${token}` } }),
        fetch(`${process.env.REACT_APP_API_URL}/Cursos`, { headers: { 'Authorization': `Bearer ${token}` } }),
        fetch(`${process.env.REACT_APP_API_URL}/Criterios`, { headers: { 'Authorization': `Bearer ${token}` } })
      ]);
      if (resPer.ok) setPeriodos(await resPer.json());
      if (resCur.ok) setCursos(await resCur.json());
      if (resCri.ok) setCriterios(await resCri.json());
    } catch (e) { console.error(e); }
  };

  const cargarAulas = async (periodoId) => {
    const token = localStorage.getItem('token');
    const res = await fetch(`${process.env.REACT_APP_API_URL}/Aulas/PorPeriodo/${periodoId}`, { headers: { 'Authorization': `Bearer ${token}` } });
    if (res.ok) setAulas(await res.json());
  };

  const handleCargarPanel = async () => {
    if (!filtros.periodoId || !filtros.aulaId || !filtros.cursoId) return alert("Selecciona todos los filtros.");
    const token = localStorage.getItem('token');
    
    try {
      const [resAlumnos, resActividades, resNotasHistorial] = await Promise.all([
        fetch(`${process.env.REACT_APP_API_URL}/Alumnos/PorAula/${filtros.periodoId}/${filtros.aulaId}`, { headers: { 'Authorization': `Bearer ${token}` } }),
        fetch(`${process.env.REACT_APP_API_URL}/Actividades/PorAulaYCurso/${filtros.aulaId}/${filtros.cursoId}/${filtros.bimestre}`, { headers: { 'Authorization': `Bearer ${token}` } }),
        fetch(`${process.env.REACT_APP_API_URL}/Calificaciones/PorAulaYCurso/${filtros.aulaId}/${filtros.cursoId}/${filtros.bimestre}`, { headers: { 'Authorization': `Bearer ${token}` } })
      ]);
      
      if (resAlumnos.ok) setAlumnos(await resAlumnos.json());
      if (resActividades.ok) setActividades(await resActividades.json());
      
      if (resNotasHistorial.ok) {
        const notasDb = await resNotasHistorial.json();
        const notasMapeadas = {};
        notasDb.forEach(n => { notasMapeadas[`${n.alumnoId}_${n.actividadId}`] = n.nota; });
        setNotas(notasMapeadas);
      } else {
        setNotas({});
      }
    } catch (e) { console.error(e); }
  };

  const handleCrearActividad = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem('token');
    const payload = {
      cursoId: parseInt(filtros.cursoId), aulaId: parseInt(filtros.aulaId),
      criterioId: parseInt(nuevaActividad.criterioId), nombre: nuevaActividad.nombre,
      bimestre: filtros.bimestre, activo: true
    };

    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/Actividades`, {
        method: 'POST', headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      if (res.ok) {
        const actCreada = await res.json();
        setActividades([...actividades, actCreada]); 
        setNuevaActividad({ nombre: '', criterioId: '' });
        setMostrandoFormulario(false);
      }
    } catch (e) { console.error(e); }
  };

  // --- BOTÓN ELIMINAR ACTIVIDAD (SOLO SUPERADMIN) ---
  const handleEliminarActividad = async (actividadId) => {
    if (!window.confirm("¿ATENCIÓN SUPERADMIN: Seguro que deseas eliminar esta actividad? Se borrarán irrevocablemente TODAS las notas de los alumnos en esta columna.")) return;
    
    const token = localStorage.getItem('token');
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/Actividades/${actividadId}`, {
        method: 'DELETE',
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (res.ok) {
        setActividades(actividades.filter(a => a.id !== actividadId));
        alert("Columna eliminada con éxito.");
      } else {
        alert("Error al eliminar la actividad de la base de datos.");
      }
    } catch (error) { console.error(error); }
  };

  const handleCambioNota = (alumnoId, actividadId, valor) => {
    setNotas(prev => ({ ...prev, [`${alumnoId}_${actividadId}`]: valor }));
  };

  const calcularPromedio = (alumnoId) => {
    if (actividades.length === 0) return 0;
    let notaFinal = 0;

    criterios.forEach(criterio => {
      const actsDelCriterio = actividades.filter(a => a.criterioId === criterio.id);
      if (actsDelCriterio.length > 0) {
        let sumaNotasCriterio = 0, notasIngresadas = 0;
        actsDelCriterio.forEach(act => {
          const notaText = notas[`${alumnoId}_${act.id}`];
          if (notaText && !isNaN(notaText)) {
            sumaNotasCriterio += parseFloat(notaText);
            notasIngresadas++;
          }
        });
        if (notasIngresadas > 0) notaFinal += (sumaNotasCriterio / notasIngresadas) * (criterio.porcentaje / 100);
      }
    });
    return notaFinal;
  };

  const formatearNota = (notaNumero) => {
    if (notaNumero === 0) return <span className="text-slate-400">-</span>;
    let letra = 'C', color = 'text-red-600';
    if (notaNumero >= 17.5) { letra = 'AD'; color = 'text-blue-600'; }
    else if (notaNumero >= 13.5) { letra = 'A'; color = 'text-green-600'; }
    else if (notaNumero >= 10.5) { letra = 'B'; color = 'text-yellow-600'; }

    return (
      <div className="flex flex-col items-center justify-center leading-tight">
        <span className="font-bold text-slate-800 text-lg">{notaNumero.toFixed(2)}</span>
        <span className={`text-xs font-black ${color} bg-slate-100 px-2 py-0.5 rounded-full mt-1`}>{letra}</span>
      </div>
    );
  };

  const handleGuardarTodo = async () => {
    setGuardando(true);
    const token = localStorage.getItem('token');
    const peticiones = [];

    Object.keys(notas).forEach(key => {
      if(notas[key] !== '') {
        const [alumnoId, actividadId] = key.split('_');
        const payload = { 
          alumnoId: parseInt(alumnoId), actividadId: parseInt(actividadId), 
          nota: parseFloat(notas[key]), activo: true 
        };
        peticiones.push(
          fetch(`${process.env.REACT_APP_API_URL}/Calificaciones`, {
            method: 'POST', headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
          })
        );
      }
    });

    try {
      await Promise.all(peticiones);
      alert('¡Todas las calificaciones se guardaron con éxito en la Base de Datos!');
    } catch (e) {
      console.error(e); alert('Hubo un error al guardar.');
    } finally { setGuardando(false); }
  };

  return (
    <div className="min-h-screen bg-gray-100 flex">
      {/* MENÚ LATERAL UNIVERSAL */}
      <Sidebar />

      {/* ÁREA PRINCIPAL */}
      <main className="flex-1 p-6 overflow-hidden flex flex-col">
        <header className="mb-4">
          <h1 className="text-2xl font-bold text-slate-800 flex items-center gap-2"><BookOpen className="text-blue-600" /> Matriz de Evaluación Ponderada</h1>
        </header>

        {/* BARRA DE FILTROS */}
        <div className="bg-white p-4 rounded-xl shadow-sm border border-slate-100 mb-4 flex-shrink-0">
          <div className="grid grid-cols-1 md:grid-cols-5 gap-4 items-end">
            <div><label className="block text-xs font-bold text-slate-500 mb-1">Año Escolar</label>
              <select value={filtros.periodoId} onChange={e => setFiltros({...filtros, periodoId: e.target.value})} className="w-full p-2 border rounded bg-slate-50 text-sm outline-none"><option value="">Seleccionar</option>{periodos.map(p => <option key={p.id} value={p.id}>{p.nombre}</option>)}</select>
            </div>
            <div><label className="block text-xs font-bold text-slate-500 mb-1">Aula y Nivel</label>
              <select value={filtros.aulaId} onChange={e => setFiltros({...filtros, aulaId: e.target.value})} disabled={!filtros.periodoId} className="w-full p-2 border rounded bg-slate-50 text-sm outline-none"><option value="">Seleccionar</option>{aulas.map(a => <option key={a.id} value={a.id}>{a.grado} "{a.seccion}" ({a.nivel})</option>)}</select>
            </div>
            <div><label className="block text-xs font-bold text-slate-500 mb-1">Curso</label>
              <select value={filtros.cursoId} onChange={e => setFiltros({...filtros, cursoId: e.target.value})} className="w-full p-2 border rounded bg-slate-50 text-sm outline-none"><option value="">Seleccionar</option>{cursos.map(c => <option key={c.id} value={c.id}>{c.nombre}</option>)}</select>
            </div>
            <div><label className="block text-xs font-bold text-slate-500 mb-1">Bimestre</label>
              <select value={filtros.bimestre} onChange={e => setFiltros({...filtros, bimestre: e.target.value})} className="w-full p-2 border rounded bg-slate-50 text-sm outline-none">
                <option value="Bimestre 1">Bimestre 1</option><option value="Bimestre 2">Bimestre 2</option>
              </select>
            </div>
            <button onClick={handleCargarPanel} className="bg-slate-800 text-white p-2 rounded hover:bg-slate-900 font-medium text-sm flex justify-center items-center gap-2">Cargar Matriz</button>
          </div>
        </div>

        {/* CONTENEDOR DEL EXCEL */}
        {alumnos.length > 0 && (
          <div className="bg-white rounded-xl shadow-sm border border-slate-100 flex-1 overflow-hidden flex flex-col">
            
            {/* Cabecera de Acciones */}
            <div className="bg-slate-50 border-b p-4 flex justify-between items-center flex-shrink-0">
              <div className="flex gap-2">
                {!mostrandoFormulario ? (
                  <button onClick={() => setMostrandoFormulario(true)} className="bg-blue-100 text-blue-700 px-4 py-2 rounded-lg font-medium text-sm flex items-center gap-2 hover:bg-blue-200"><Plus size={16}/> Agregar Columna (Actividad)</button>
                ) : (
                  <form onSubmit={handleCrearActividad} className="flex gap-2 items-center bg-blue-50 p-2 rounded-lg border border-blue-200">
                    <input type="text" placeholder="Ej: Examen Sem. 1" required value={nuevaActividad.nombre} onChange={e => setNuevaActividad({...nuevaActividad, nombre: e.target.value})} className="p-1.5 text-sm border rounded w-40" />
                    <select required value={nuevaActividad.criterioId} onChange={e => setNuevaActividad({...nuevaActividad, criterioId: e.target.value})} className="p-1.5 text-sm border rounded w-40">
                      <option value="">-- Peso --</option>
                      {criterios.map(c => <option key={c.id} value={c.id}>{c.nombre} ({c.porcentaje}%)</option>)}
                    </select>
                    <button type="submit" className="bg-blue-600 text-white px-3 py-1.5 rounded text-sm font-medium">Crear</button>
                    <button type="button" onClick={() => setMostrandoFormulario(false)} className="text-slate-500 px-2">Cancelar</button>
                  </form>
                )}
              </div>
              <button onClick={handleGuardarTodo} disabled={guardando} className="bg-green-600 text-white px-6 py-2 rounded-lg font-medium hover:bg-green-700 flex items-center gap-2">
                <Save size={18} /> {guardando ? 'Guardando...' : 'Guardar Registros'}
              </button>
            </div>

            {/* TABLA DE EXCEL */}
            <div className="flex-1 overflow-auto">
              <table className="w-full text-left border-collapse whitespace-nowrap">
                <thead className="sticky top-0 bg-white z-10 shadow-sm">
                  <tr className="border-b text-xs text-slate-500 uppercase">
                    <th className="p-3 bg-slate-50 font-bold sticky left-0 z-20 w-10">N°</th>
                    <th className="p-3 bg-slate-50 font-bold sticky left-10 z-20 min-w-[200px]">Apellidos y Nombres</th>
                    
                    {/* COLUMNAS DINÁMICAS */}
                    {actividades.map(act => {
                      const crit = criterios.find(c => c.id === act.criterioId);
                      return (
                        <th key={act.id} className="p-2 border-l border-slate-200 text-center min-w-[120px] bg-white group">
                          <div className="flex items-center justify-center gap-1">
                            <p className="text-slate-800 font-bold truncate max-w-[90px]" title={act.nombre}>{act.nombre}</p>
                            
                            {/* BOTÓN BASURA: Solo se muestra al pasar el mouse encima Y si es SuperAdmin */}
                            {rolUsuario === 'SUPERADMIN' && (
                              <button onClick={() => handleEliminarActividad(act.id)} className="text-red-400 hover:text-red-600 opacity-0 group-hover:opacity-100 transition-opacity" title="Eliminar Columna">
                                <Trash2 size={14} />
                              </button>
                            )}
                          </div>
                          <p className="text-[10px] text-blue-600">{crit?.nombre} ({crit?.porcentaje}%)</p>
                        </th>
                      );
                    })}
                    
                    <th className="p-3 border-l border-slate-300 bg-slate-100 text-center font-bold text-slate-800 sticky right-0 z-20 w-32">
                      <Calculator size={14} className="inline mr-1" /> PROMEDIO
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {alumnos.map((alumno, index) => {
                    const promedioNum = calcularPromedio(alumno.id);
                    return (
                      <tr key={alumno.id} className="border-b hover:bg-slate-50">
                        <td className="p-3 bg-white sticky left-0 z-10 text-slate-400">{index + 1}</td>
                        <td className="p-3 bg-white sticky left-10 z-10 font-bold text-slate-700 shadow-[2px_0_5px_-2px_rgba(0,0,0,0.1)]">{alumno.apellidos}, {alumno.nombres}</td>
                        
                        {actividades.map(act => (
                          <td key={act.id} className="p-1 border-l text-center">
                            <input 
                              type="number" step="0.1" min="0" max="20"
                              value={notas[`${alumno.id}_${act.id}`] || ''}
                              onChange={(e) => handleCambioNota(alumno.id, act.id, e.target.value)}
                              className="w-16 p-1.5 border rounded text-center font-medium focus:ring-2 focus:ring-blue-500 outline-none"
                            />
                          </td>
                        ))}
                        <td className="p-3 border-l bg-slate-50 text-center text-lg sticky right-0 z-10 shadow-[-2px_0_5px_-2px_rgba(0,0,0,0.1)]">
                          {formatearNota(promedioNum)}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>

          </div>
        )}
      </main>
    </div>
  );
};
export default Calificaciones;